import { PageType } from '../../common/page-types'

export type AdURIPart = string | string[]

export class AdURI {
    constructor(private parts: AdURIPart = []) { }

    public add(s: AdURIPart) {
        return new AdURI([...[].concat(this.parts), ...[].concat(s)])
    }

    public addIf(condition: boolean, part: AdURIPart): AdURI {
        return condition ? this.add(part) : this
    }

    public toString(separator = '/'): string {
        const parts = [].concat(this.parts).filter((_) => _)
        return parts.length ? separator + parts.join(separator) : ''
    }
}

export type AdURIFormatter = (
    account: string,
    site: string,
    ancestry?: string[],
    type?: PageType
) => string
